export default __webpack_public_path__ + "static/media/download_page_phone_item_ikara.5ce24767.png";